"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var service_definition_1 = require("./../services/service-definition");
var topic_notification_deregistration_request_serialiser_1 = require("./../services/topic-notifications/topic-notification-deregistration-request-serialiser");
var topic_notification_descendant_event_serialiser_1 = require("./../services/topic-notifications/topic-notification-descendant-event-serialiser");
var topic_notification_deselection_serialiser_1 = require("./../services/topic-notifications/topic-notification-deselection-serialiser");
var topic_notification_event_serialiser_1 = require("./../services/topic-notifications/topic-notification-event-serialiser");
var topic_notification_selection_serialiser_1 = require("./../services/topic-notifications/topic-notification-selection-serialiser");
exports.TOPIC_NOTIFICATION_DEREGISTRATION = {
    id: 91,
    request: topic_notification_deregistration_request_serialiser_1.TopicNotificationDeregistrationRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.TOPIC_NOTIFICATION_EVENTS = {
    id: 92,
    request: topic_notification_event_serialiser_1.TopicNotificationEventSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.TOPIC_DESCENDANT_EVENTS = {
    id: 93,
    request: topic_notification_descendant_event_serialiser_1.TopicNotificationDescendantEventSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.TOPIC_NOTIFICATION_SELECTION = {
    id: 94,
    request: topic_notification_selection_serialiser_1.TopicNotificationSelectionSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.TOPIC_NOTIFICATION_DESELECTION = {
    id: 95,
    request: topic_notification_deselection_serialiser_1.TopicNotificationDeselectionSerialiser,
    response: service_definition_1.NullSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-notifications-services.js
// module id = 1401
// module chunks = 1